/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Group_Type_LabelInputs */



/**
* | output |
* | --- |
* | "Group Type" |
*
* @param {Merge_Event_Group_Group_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_group_type_label = /** @type {((inputs?: Merge_Event_Group_Group_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Group_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type de groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppentyp")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo di gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип группы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo de grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("组类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループタイプ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo de grupo")
	return /** @type {LocalizedString} */ ("Group Type")
});